import { motion } from "framer-motion";
import {
  ChatCircleDots,
  MapTrifold,
  Rocket,
  Lifebuoy,
} from "@phosphor-icons/react";

const stepIcons = [ChatCircleDots, MapTrifold, Rocket, Lifebuoy];

export default function ProcessSection({ t }) {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{ background: "#0A0F1A" }}
    >
      {/* Subtle glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full bg-[#0055FF]/5 blur-[160px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="text-center mb-20"
        >
          <span className="text-sm uppercase tracking-[0.2em] text-[#00F0FF] font-semibold mb-4 block font-chivo">
            {t.process.overline}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-white font-outfit">
            {t.process.title}
          </h2>
        </motion.div>

        {/* Horizontal layout */}
        <div className="relative">
          {/* Connecting line (desktop only) — behind icons via z-0 */}
          <div className="hidden lg:block absolute top-[52px] left-[calc(12.5%+24px)] right-[calc(12.5%+24px)] h-px bg-gradient-to-r from-[#00F0FF]/40 via-[#0055FF]/30 to-[#00F0FF]/40 z-0" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {t.process.steps.map((step, i) => {
              const Icon = stepIcons[i];
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ delay: i * 0.15, duration: 0.5 }}
                  data-testid={`process-step-${i}`}
                  className="relative flex flex-col items-center text-center group"
                >
                  {/* Number + Icon circle */}
                  <div className="relative mb-8 z-10">
                    <div className="w-[104px] h-[104px] rounded-full bg-[#0A0F1A] border border-white/10 flex items-center justify-center group-hover:border-[#00F0FF]/40 group-hover:bg-[#0d1326] transition-all duration-500">
                      <Icon size={40} weight="duotone" className="text-[#00F0FF] group-hover:scale-110 transition-transform duration-300" />
                    </div>
                    {/* Step number badge */}
                    <span className="absolute -top-1 -right-1 w-8 h-8 rounded-full bg-[#0055FF] text-white text-sm font-bold flex items-center justify-center font-outfit shadow-[0_0_12px_rgba(0,85,255,0.5)]">
                      {i + 1}
                    </span>
                  </div>

                  {/* Text */}
                  <h3 className="text-xl font-semibold text-white mb-3 font-outfit">
                    {step.title}
                  </h3>
                  <p className="text-sm text-[#94A3B8] font-chivo leading-relaxed max-w-[240px]">
                    {step.desc}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
